__turbopack_context__.v({
  "button": "KZok4q_button",
  "container": "KZok4q_container",
  "isCompact": "KZok4q_isCompact",
});
